import "core-js/modules/es.array.map.js";
import React from 'react';
import FontAwesome from 'react-fontawesome';
import RenderQuestion from "./RenderQuestion";
import ModalWrapper from "../../../../components/SchoolModals/ModalWrapper";
import AsyncButton from "../../../../components/core/button/AsyncButton";
import { _RequirementBody, _RequirementFooter, _RequirementHeader } from "../../../../components/Modals/RequirementModal/style";
import { _ReAnswerQuestionsButton } from "./style";
// eslint-disable-line import/no-unresolved
import { useId } from '@applyboard/ui-components';
var QuestionsModal = function QuestionsModal(_ref) {
  var dirty = _ref.dirty,
    formSyncErrors = _ref.formSyncErrors,
    handleSubmit = _ref.handleSubmit,
    onToggleQuestionsModal = _ref.onToggleQuestionsModal,
    questions = _ref.questions,
    showRetryRejectionsText = _ref.showRetryRejectionsText,
    reduxFormSubmit = _ref.reduxFormSubmit,
    duplicateQuestionsVisible = _ref.duplicateQuestionsVisible,
    requirementTitle = _ref.requirementTitle,
    onShowDuplicateQuestions = _ref.onShowDuplicateQuestions,
    apiErrors = _ref.apiErrors,
    waitingForSubmit = _ref.waitingForSubmit,
    userPermissions = _ref.userPermissions;
  var headingId = useId();
  return /*#__PURE__*/React.createElement(ModalWrapper, {
    onRequestClose: onToggleQuestionsModal,
    overflow: "visible",
    padding: "0px",
    maxHeight: "100%",
    aria: {
      labelledby: headingId
    }
  }, /*#__PURE__*/React.createElement(_RequirementHeader, {
    id: headingId
  }, /*#__PURE__*/React.createElement("span", null, requirementTitle, " Questions")), /*#__PURE__*/React.createElement(_RequirementBody, null, /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit
  }, questions.map(function (question, idx) {
    var errors = apiErrors && !question.duplicated ? apiErrors[question.id] : undefined;
    return /*#__PURE__*/React.createElement(RenderQuestion, {
      duplicateQuestionsVisible: duplicateQuestionsVisible,
      errors: errors,
      key: idx,
      question: question,
      userPermissions: userPermissions
    });
  })), showRetryRejectionsText && /*#__PURE__*/React.createElement(_ReAnswerQuestionsButton, {
    onClick: onShowDuplicateQuestions
  }, "Correct Rejected Questions")), /*#__PURE__*/React.createElement(_RequirementFooter, {
    singleButton: true
  }, /*#__PURE__*/React.createElement(AsyncButton, {
    disabled: waitingForSubmit || !dirty || formSyncErrors && formSyncErrors.disableSubmit || !userPermissions.fulfil_requirement,
    onClick: reduxFormSubmit,
    buttonHeight: "40px",
    buttonWidth: "100px"
  }, waitingForSubmit ? /*#__PURE__*/React.createElement(FontAwesome, {
    name: "circle-o-notch",
    spin: true
  }) : null, "Submit")));
};
export default QuestionsModal;